export default __webpack_public_path__ + "static/media/team2.f54d1a6f.png";